<template>
  <div id="app">
    <HelloWorld v-if="isReady"></HelloWorld>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import $ from 'jquery'

export default {
  name: 'App',
  data() {
    return {
      isReady: false
    }
  },
  components: {
    HelloWorld
  },
  methods: {
    ready: function () {
      this.isReady = true;
    }
  },
  mounted: function() {
    $(document).ready(this.ready());
  }
}
</script>

<style lang="scss">

#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
  width: 100vw;
  height: 100vh;
}

body {
  padding: 0;
  margin: 0;
  overflow-x: hidden;
}


</style>
